import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Link from '../../Link';

const Item = styled(Link)`
  color: ${({ theme, color }) =>
    color === 'negative'
      ? theme.components.menu.itemVertical.colorNegative
      : theme.components.menu.itemVertical.color};
  font-weight: ${(props) =>
    props.theme.components.menu.itemVertical.fontWeight};
  font-size: ${(props) => props.theme.components.menu.itemVertical.fontSize};
  letter-spacing: ${(props) =>
    props.theme.components.menu.itemVertical.letterSpacing};
  text-transform: ${(props) =>
    props.theme.components.menu.itemVertical.textTransform};
  padding: ${(props) => props.theme.components.menu.itemVertical.padding};

  &:hover {
    color: ${({ theme, color }) =>
      color === 'negative'
        ? theme.components.menu.itemVertical.hoverNegative
        : theme.components.menu.itemVertical.hover};
  }

  &.active {
    color: ${({ theme, color }) =>
      color === 'negative'
        ? theme.components.menu.itemVertical.hoverNegative
        : theme.components.menu.itemVertical.hover};
  }
`;

function NavbarItemVertical({ link, children, color, ...other }) {
  return (
    <Item
      to={link}
      activeClassName="active"
      partiallyActive={false}
      color={color}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    >
      {children}
    </Item>
  );
}

NavbarItemVertical.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['default', 'negative']),
};

NavbarItemVertical.defaultProps = {
  color: 'default',
};

export default NavbarItemVertical;
